import cn from 'classnames';
import { StaticImageData } from 'next/image';
import Image from '@/Framework/Router/Next/Image';

import styles from '@/finsight/ui/components/staticPages/Policies/Certificates/certificates.scss';

interface ICertificate {
  id: string,
  src: StaticImageData,
  alt: string,
  className?: string,
}

interface IProps {
  items: ICertificate[],
}

const Certificates = ({ items }: IProps) => (
  <div className={ styles.certificatesContainer }>
    { items.map((certificate: ICertificate) => (
      <Image
        key={ certificate.id }
        src={ certificate.src }
        alt={ certificate.alt }
        className={ cn(styles.certificate, certificate.className) }
        width={ 80 }
        height={ 80 }
      />
    )) }
  </div>
);

export default Certificates;
